import type { Theme } from '@mui/material/styles'

type Owner = { theme: Theme }

const Misc = () => ({
  MuiCssBaseline: {
    // Atencao: o styleOverrides do CssBaseline recebe o THEME direto, nao
    // `{ theme }` como os demais. Destruturar aqui derruba a aplicacao inteira.
    styleOverrides: (theme: Theme) => ({
      body: { backgroundColor: theme.palette.customColors.bodyBg },
      '*::-webkit-scrollbar': { width: 6, height: 6 },
      '*::-webkit-scrollbar-thumb': {
        background: `rgba(${theme.palette.customColors.mainRgb}, 0.25)`,
        borderRadius: 3,
      },
    }),
  },
  MuiPaper: {
    styleOverrides: { root: { backgroundImage: 'none' } },
  },
  MuiLink: {
    styleOverrides: { root: { textDecoration: 'none' } },
  },
  MuiAppBar: {
    styleOverrides: {
      colorDefault: ({ theme }: Owner) => ({ backgroundColor: theme.palette.background.paper }),
    },
  },
  MuiList: {
    styleOverrides: {
      root: {
        '& .MuiListItem-root:not(.MuiListItem-dense)': { paddingLeft: 16, paddingRight: 16 },
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        minWidth: '6rem !important',
        '&.MuiTablePagination-select': { minWidth: '1.5rem !important' },
      },
    },
  },

  // --- especifico do painel (o Drive nao usa estes componentes) --------------
  MuiTextField: {
    defaultProps: { size: 'small' as const },
  },
  MuiTab: {
    styleOverrides: { root: { textTransform: 'none' as const, fontWeight: 500, minHeight: 44 } },
  },
  MuiAlert: {
    styleOverrides: { root: ({ theme }: Owner) => ({ borderRadius: theme.shape.borderRadius }) },
  },
  MuiListItemButton: {
    styleOverrides: { root: ({ theme }: Owner) => ({ borderRadius: theme.shape.borderRadius }) },
  },
})

export default Misc
